export abstract class SecretsManagerProvider {
  abstract getSecret(secretId: string): Promise<string>
}
